/**
 * アナリティクスへのイベント送信
 * @param gl
 * @param ga
 */
export const sendga = (gl, ga = 'navigation') => {
    gtag('event', ga, {
        event_category: 'DQ×LOFT2021',
        event_label: gl
    });
};
